// @ts-nocheck
import { Box, Grid, InputLabel, Typography } from "@mui/material";
import {
  CustomIconButton,
  CustomInfoButton,
} from "../../../components/Custom/CustomIconButton";
import WhiteFile from "./../../../assets/svgs/white-file.svg";
import styles from "./../contractDetails.module.css";
import { Close } from "@mui/icons-material";
import PropTypes from "prop-types";

export default function AdditionalDocument({
  values,
  readOnly,
  existingData,
  setFieldValue,
  status,
}) {
  return (
    <Grid contianer>
      <Grid item xs={12}>
        {values?.attachments?.length > 0 && (
          <InputLabel
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: "0.25rem",
              padding: "0.25rem",
              paddingLeft: "0.75rem",
            }}
          >
            Additional Documents{" "}
            <CustomInfoButton
              placement="right"
              title="Any additional documents to send with contract"
            />
          </InputLabel>
        )}

        {values?.attachments?.length > 0 && (
          <Box className={styles["file-name-container"]}>
            {values.attachments.map((file, index) => (
              <Box key={index} className={styles["file-btn-container"]}>
                <img alt={"File image"} src={WhiteFile} />
                <Typography
                  className={`${styles["label"]} ${styles["color-pink"]}`}
                  sx={{
                    fontSize: "0.8rem",
                    cursor: "pointer",
                    userSelect: "none",
                    "&:active": {
                      opacity: "0.8",
                    },
                  }}
                  onClick={() => {
                    const anchor = document.createElement("a");
                    anchor.href = file.url;
                    anchor.download = file.name;
                    anchor.target = "_blank";
                    anchor.click();
                  }}
                >
                  {file.name}
                </Typography>
                {!status && (
                  <CustomIconButton
                    sx={{
                      backgroundColor: "white",
                      padding: 0,
                      "&:hover": {
                        backgroundColor: "white",
                        opacity: "0.8",
                      },
                    }}
                    onClick={() => {
                      const updated = [...values.attachments];
                      updated.splice(index, 1);
                      setFieldValue("attachments", updated);
                    }}
                  >
                    <Close sx={{ fontSize: "1rem", color: "black" }} />
                  </CustomIconButton>
                )}
              </Box>
            ))}
          </Box>
        )}
      </Grid>
    </Grid>
  );
}

AdditionalDocument.propTypes = {
  setCurrentStep: PropTypes.func,
  setConData: PropTypes.func,
  existingData: PropTypes.object || null,
  readOnly: PropTypes.bool,
  status: PropTypes.string,
  values: PropTypes.object,
  setFieldValue: PropTypes.func,
  submitForm: PropTypes.func,
  setValues: PropTypes.func,
  errors: PropTypes.object,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  touched: PropTypes.func,
  handleContractUpload: PropTypes.func,
  clearFile: PropTypes.func,
  file: PropTypes.any,
  showErrors: PropTypes.bool,
};